import React, { useState } from 'react';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { TAB_FOOTER_MODE, TAB_IDS } from './SendoutInterviewDetailsDrawer.constants';
import { SendoutInterviewDetailsTabs } from './SendoutInterviewDetailsTabs';

export const SendoutInterviewDetailsDrawer = ({
  interviewId,
  onClose = () => {},
  onEditDebrief = () => {},
  onViewDebrief = () => {}
}) => {
  const [selectedTab, setSelectedTab] = useState(TAB_IDS.InterviewDetails);
  const footerMode = TAB_FOOTER_MODE[selectedTab];

  const footer =
    footerMode === TAB_FOOTER_MODE[TAB_IDS.PreparationCall] ? (
      <FPButtonBuilder
        GridContainerProps={{ spacing: 2 }}
        buttonDefinitions={[
          {
            props: {
              text: strings.shared.ui.close,
              variant: 'outlined',
              onClick: onClose
            },
            GridItemProps: { md: 3 }
          },
          {
            props: {
              text: strings.shared.ui.update,
              variant: 'contained',
              disabled: true,
              onClick: () => {
                // TODO: Implement submit functionality
              }
            },
            GridItemProps: { md: 3 }
          }
        ]}
      />
    ) : undefined;

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: strings.sendoutsV2.drawers.sendoutInterviewDetails.title }}
      footer={footer}
      onClose={onClose}
      hasPaddingContent={false}
    >
      <SendoutInterviewDetailsTabs
        interviewId={interviewId}
        onChangeTabIndex={(event, tabId) => setSelectedTab(tabId)}
        onEditDebrief={onEditDebrief}
        onViewDebrief={onViewDebrief}
        selectedTab={selectedTab}
      />
    </FPDrawer>
  );
};
